import { render, staticRenderFns } from "./HolidaysTableBody.vue?vue&type=template&id=02737f0c&"
import script from "./HolidaysTableBody.vue?vue&type=script&lang=js&"
export * from "./HolidaysTableBody.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysTableBody.vue?vue&type=style&index=0&id=02737f0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports